import type { ReactNode } from 'react'
import React, { PureComponent } from 'react'

import FunctionalCarousel from '@vfuk/core-functional-carousel'
import { getDataSelector } from '@vfuk/core-base-props'

import type { CardCarouselProps } from './CardCarousel.types'

export class CardCarousel extends PureComponent<CardCarouselProps> {
  private componentName = 'CardCarousel'

  public static defaultProps: Partial<CardCarouselProps> = {
    arrows: {
      position: 'overlap',
    },
    pager: {
      inverse: false,
    },
  }

  public render(): ReactNode {
    return (
      <FunctionalCarousel
        slidesToShow={this.props.slidesToShow}
        slidesToScroll={this.props.slidesToScroll}
        id={this.props.id}
        srName={this.props.srName}
        arrows={{
          position: this.props.arrows!.position,
          onClick: this.props.arrows!.onClick,
        }}
        pager={{
          position: 'outside',
          inverse: this.props.pager!.inverse,
          onClick: this.props.pager!.onClick,
        }}
        infiniteLoop={this.props.infiniteLoop}
        allowOverflow={this.props.allowOverflow}
        elevatedCards={this.props.elevatedCards}
        dataSelectorPrefix={getDataSelector(this.props.dataSelectorPrefix)}
        dataAttributes={{ 'data-component-name': this.componentName, ...this.props.dataAttributes }}
      >
        {this.props.children}
      </FunctionalCarousel>
    )
  }
}

export default CardCarousel
